import Api from '@/services/Index';

const getInformationData = async (nationalId) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/promotional/processes/school-data/'+nationalId);
}
const saveInformationData = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/promotional/processes',data);
}
const addPreference = async (data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.post('/promotional/process/preferences',data);
}
const getPreferences = async (config) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/promotional/process/preferences',config);
}
const showPreference = async (id) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.get('/promotional/process/preferences/'+id);
}
const updatePreference = async (id,data) => {
    Api.defaults.baseURL = process.env.VUE_APP_ENDPOINT_STUDENT;
    return Api.put('/promotional/process/preferences/'+id,data);
}

export default {
    getInformationData,
    saveInformationData,
    addPreference,
    getPreferences,
    showPreference,
    updatePreference
}
